import { render } from "./Avatar.vue?vue&type=template&id=0933fa11&scoped=true&bindings={\"isThumbnail\":\"props\",\"avatarImageUrl\":\"data\",\"nickName\":\"data\",\"shortInfo\":\"data\",\"buttonEffect\":\"data\",\"showButtonEffect\":\"options\"}"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import "./Avatar.vue?vue&type=style&index=0&id=0933fa11&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0933fa11"

export default script